import { db } from "@repo/ui";
import { doc, onSnapshot } from "firebase/firestore";
import { X } from "lucide-react";
import { useEffect, useState } from "react";

const APP_VERSION =
	import.meta.env.VITE_APP_VERSION || __COMMIT_HASH__ || "dev";
const COMPONENT_NAME = import.meta.env.VITE_COMPONENT_NAME || "admin-frontend";

export function RefreshVersionBanner() {
	const [latestVersion, setLatestVersion] = useState<string | null>(null);
	const [dismissedVersion, setDismissedVersion] = useState<string | null>(null);

	useEffect(() => {
		return onSnapshot(doc(db, "settings", "system"), (snapshot) => {
			const latestVersions = snapshot.data()?.latestVersions as
				| Record<string, string>
				| undefined;
			const latestVersion = latestVersions?.[COMPONENT_NAME];
			setLatestVersion(
				latestVersion && latestVersion !== APP_VERSION ? latestVersion : null,
			);
		});
	}, []);

	const isStale = Boolean(latestVersion && latestVersion !== dismissedVersion);

	if (!isStale) return null;

	return (
		<div className="fixed right-4 bottom-4 z-50 flex w-[calc(100%-2rem)] max-w-xl items-center justify-between gap-4 rounded-lg border border-border bg-white px-4 py-3 text-sm shadow-lg">
			<span className="min-w-0 font-medium text-gray-900">
				A new version is available. Refresh to update.
			</span>
			<div className="flex shrink-0 items-center gap-2">
				<button
					type="button"
					className="rounded-md bg-primary px-3 py-2 font-semibold text-white hover:bg-primary/90"
					onClick={() => window.location.reload()}
				>
					Refresh
				</button>
				<button
					type="button"
					className="inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-900"
					aria-label="Dismiss update notice"
					onClick={() => setDismissedVersion(latestVersion)}
				>
					<X className="h-4 w-4" />
				</button>
			</div>
		</div>
	);
}
